export const MAX_METRIC_TABS = 10;

// will be dynamically calculated by skewness in future
export const MIN_VARIANT_SAMPLE_SIZE = 300;

export const MEASURE_RATIO_FIREBASE = "ratio_of_{event_name1}_count_and_{event_name2}_count";
export const MEASURE_RETENTION_BY_EVENT_NAME = "retention_by_{event_name}";
